import { HOTJAR_ID, HOTJAR_SV } from 'config';
import hotjar from './script';
export const initialize = () => hotjar(HOTJAR_ID, HOTJAR_SV);
